import { Cookies } from 'react-cookie';
import {
  IAuthRelativePath,
  generateUUID,
  AppConstants,
  I18nUtils,
} from '@amzn/work-spaces-web-client-core-lib';

const cookie = new Cookies();

export class ExternalAuthUrlBuilder {
  private readonly base: string;
  private url: URL;

  constructor(base: string) {
    this.base = base;
    this.url = new URL(this.base);
  }

  reset() {
    this.url = new URL(this.base);
  }

  setRedirectUri(strategy: IAuthRelativePath) {
    const port = window.location.port ? `:${window.location.port}` : '';
    this.url.searchParams.set(
      'redirect_uri',
      `https://${window.location.hostname}${port}/auth/${strategy}`
    );
  }

  setRelayStateUrl(relayStateName: string, relayStateUrl: string) {
    this.url.searchParams.set(relayStateName, relayStateUrl);
  }

  setLocale() {
    const language = cookie.get('language');
    // Use the AWSCShortbread locale mapping, which defaults to 'en_US' if language is undefined
    const locale = I18nUtils.mapToAWSCShortbreadLocale(language);
    this.url.searchParams.set('locale', locale);
  }

  setCsrfToken(csrfToken: string | null = null, addToUrl: boolean = true) {
    // If no token is provided, generate one
    const token = csrfToken ?? generateUUID();

    // Always set the cookie
    cookie.set(AppConstants.COOKIE_CSRF_TOKEN, token, { path: '/' });

    // Only add to URL if requested (for WD_LOGIN flow)
    if (addToUrl) {
      this.url.searchParams.set('state', token);
    }

    return token;
  }

  getUrl() {
    return this.url;
  }
}
